import { render, staticRenderFns } from "./CreateGrievancePage.vue?vue&type=template&id=09adaaba&scoped=true&"
import script from "./CreateGrievancePage.vue?vue&type=script&lang=ts&"
export * from "./CreateGrievancePage.vue?vue&type=script&lang=ts&"
import style0 from "./CreateGrievancePage.vue?vue&type=style&index=0&id=09adaaba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09adaaba",
  null
  
)

/* custom blocks */
import block0 from "./CreateGrievancePage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports